import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {CUSTOMER_GROUPS_CODELIST_ID} from '@dms/shared';

import {useRequiredParams} from 'shared/web';

import {CodelistDetail} from '../../components/CodelistDetail/CodelistDetail';

export function SalesCodelistDetail() {
  const {id} = useRequiredParams();

  return (
    <CodelistDetail
      breadcrumbs={[
        id === CUSTOMER_GROUPS_CODELIST_ID
          ? {
              isCurrentPage: true,
              label: i18n.t('entity.customer.labels.customer'),
            }
          : {
              label: i18n.t('page.codelists.pageTitle'),
              href: settingsRoutes.codelists,
            },
      ]}
    />
  );
}
